"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactAriaModal = _interopRequireDefault(require("react-aria-modal"));

var _Paper = _interopRequireDefault(require("../Paper"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _Button = _interopRequireDefault(require("../Button"));

var _Close = _interopRequireDefault(require("elevate-ui-icons/Close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A modal that opens above other page content to display important information or user actions.
 */
var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cancelText = _this$props.cancelText,
          cancelIcon = _this$props.cancelIcon,
          classes = _this$props.classes,
          className = _this$props.className,
          children = _this$props.children,
          confirmAction = _this$props.confirmAction,
          confirmText = _this$props.confirmText,
          confirmIcon = _this$props.confirmIcon,
          titleIcon = _this$props.titleIcon,
          maskStyles = _this$props.maskStyles,
          showFooter = _this$props.showFooter,
          style = _this$props.style,
          theme = _this$props.theme,
          title = _this$props.title,
          toggleModal = _this$props.toggleModal,
          visible = _this$props.visible;
      var underlayStyle = {
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: theme.zIndex["modal"]
      };

      if (!visible) {
        return null;
      }

      return _react["default"].createElement(_reactAriaModal["default"], {
        titleText: title,
        onExit: function onExit() {
          return toggleModal();
        },
        underlayStyle: maskStyles ? maskStyles : underlayStyle,
        dialogClass: classes.dialog,
        focusDialog: true
      }, _react["default"].createElement(_Paper["default"], {
        className: (0, _classnames["default"])(classes.root, className),
        withPadding: false,
        style: style
      }, _react["default"].createElement("header", {
        className: classes.header
      }, _react["default"].createElement("div", null, _react["default"].createElement(_Typography["default"], {
        type: "heading4",
        className: classes.title
      }, titleIcon ? titleIcon : null, title)), _react["default"].createElement("div", null, _react["default"].createElement(_Button["default"], {
        className: classes.close,
        innerClassName: classes.closeInner,
        type: "button",
        "aria-label": "Close",
        isOutlined: true,
        color: "#232c35",
        onClick: function onClick() {
          return toggleModal();
        }
      }, _react["default"].createElement(_Close["default"], null)))), _react["default"].createElement("div", {
        className: classes.body
      }, children), showFooter ? _react["default"].createElement("footer", {
        className: classes.footer
      }, _react["default"].createElement(_Button["default"], {
        type: "button",
        isOutlined: true,
        icon: cancelIcon,
        color: "#ccc",
        className: classes.cancel,
        onClick: function onClick() {
          return toggleModal();
        }
      }, cancelText), _react["default"].createElement(_Button["default"], {
        type: "button",
        color: "secondary",
        onClick: function onClick() {
          return confirmAction();
        },
        icon: confirmIcon
      }, confirmText)) : null));
    }
  }]);

  return Modal;
}(_react.Component);

_defineProperty(Modal, "defaultProps", {
  cancelText: "Cancel",
  cancelIcon: false,
  confirmAction: function confirmAction() {
    return null;
  },
  confirmText: "Confirm",
  confirmIcon: false,
  showFooter: true,
  visible: false
});

var styles = function styles(theme) {
  var _root;

  return {
    root: (_root = {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      margin: "0 auto",
      minWidth: "95%",
      maxWidth: "85%",
      maxHeight: "70vh",
      border: "none",
      boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
      overflow: "hidden"
    }, _defineProperty(_root, theme.breakpoints(450), {
      minWidth: "450px"
    }), _defineProperty(_root, theme.breakpoints(900), {
      maxHeight: "90vh"
    }), _root),
    dialog: {
      position: "relative",
      maxHeight: "90vh"
    },
    header: {
      flex: "0 0 auto",
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      padding: "12px 6px 12px 24px",
      margin: "0 auto",
      borderBottom: "1px solid ".concat(theme.colors["gray100"]),
      textAlign: "left"
    },
    title: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-start",
      alignItems: "center",
      "& svg": {
        marginRight: "8px"
      }
    },
    close: {
      width: "42px",
      height: "42px",
      borderRadius: "50%",
      borderColor: "transparent",
      "&:hover": {
        "& svg": {
          fill: theme.colors.white
        }
      }
    },
    closeInner: {
      padding: "0"
    },
    body: {
      width: "100%",
      flex: "0 1 auto",
      padding: "18px 24px",
      overflowY: "scroll",
      WebkitOverflowScrolling: "touch"
    },
    footer: {
      flex: "0 0 auto",
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-end",
      alignItems: "center",
      width: "100%",
      padding: "12px 16px",
      backgroundColor: theme.colors["gray050"],
      borderTop: "1px solid ".concat(theme.colors["gray100"]),
      "& > * + *": {
        marginLeft: "12px"
      }
    },
    cancel: {
      borderColor: "transparent"
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "EuiModal"
})(Modal);

exports["default"] = _default;